/**
 * 前端权限工具 — 与 mock-auth-guard 权限码对齐
 */
import projectAuth, { authState } from '@/utils/projectAuth'

export const PERMS = {
  TEMPLATE_EDIT: 'template:edit',
  SCHEDULE_EDIT: 'schedule:edit',
  REPORT_VIEW: 'report:view',
  REPORT_VIEW_OWN: 'report:view_own',
  REPORT_SUBMIT: 'report:submit',
  ISSUE_MANAGE: 'issue:manage',
  STAFF_MANAGE: 'staff:manage',
  PERMISSION_MANAGE: 'permission:manage'
}

export function getPermissions() {
  const ctx = authState.context
  return (ctx && ctx.permissions) || []
}

export function hasPermission(code) {
  if (!code) return true
  if (Array.isArray(code)) return code.some(c => getPermissions().includes(c))
  return getPermissions().includes(code)
}

export function installPermissionDirective(Vue) {
  Vue.directive('permission', {
    inserted(el, binding) {
      if (!hasPermission(binding.value)) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    },
    update(el, binding) {
      if (!hasPermission(binding.value)) {
        el.style.display = 'none'
      } else {
        el.style.display = ''
      }
    }
  })
}

export const ROUTE_PERMISSIONS = {
  '/config/plans': PERMS.TEMPLATE_EDIT,
  '/config/questions': PERMS.TEMPLATE_EDIT,
  '/config/datasources': PERMS.TEMPLATE_EDIT,
  '/schedule/list': PERMS.SCHEDULE_EDIT,
  '/schedule/calendar': PERMS.SCHEDULE_EDIT,
  '/schedule/special': PERMS.SCHEDULE_EDIT,
  '/result/daily': PERMS.REPORT_VIEW,
  '/result/issues': PERMS.ISSUE_MANAGE,
  '/result/vision-records': PERMS.ISSUE_MANAGE,
  '/settings/projects': PERMS.PERMISSION_MANAGE,
  '/settings/staff': PERMS.STAFF_MANAGE,
  '/settings/roles': PERMS.PERMISSION_MANAGE,
  '/settings/notifications': PERMS.ISSUE_MANAGE,
  '/settings/ai': PERMS.PERMISSION_MANAGE,
  '/settings/vision-import': PERMS.PERMISSION_MANAGE,
  '/settings/assistant-rules': PERMS.ISSUE_MANAGE
}

export function permissionForRoute(path) {
  if (path === '/') return null
  if (path.startsWith('/config/plans/') && path.endsWith('/edit')) return PERMS.TEMPLATE_EDIT
  const base = Object.keys(ROUTE_PERMISSIONS).find(p => path === p || path.startsWith(p + '/'))
  return base ? ROUTE_PERMISSIONS[base] : null
}

export default { PERMS, hasPermission, getPermissions, permissionForRoute, installPermissionDirective }
